import * as Yup from "yup";
import { normalizeKycCountryValue } from "../../../constants/kycCountryCodes";

export const billingInfoInitialValues = {
  company_name: "",
  internal_company_number: "",
  first_name: "",
  last_name: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  country: "",
  postal_code: "",
  email: "",
  phone: "",
};

export const billingInfoInitialValidationSchema = Yup.object().shape({
  company_name: Yup.string()
    .max(255, "Company name cannot exceed 255 characters")
    .nullable(),

  internal_company_number: Yup.string()
    .max(64, "Internal company number cannot exceed 64 characters")
    .nullable(),

  first_name: Yup.string()
    .required("First name is required")
    .max(255, "First name cannot exceed 255 characters"),

  last_name: Yup.string()
    .required("Last name is required")
    .max(255, "Last name cannot exceed 255 characters"),

  address1: Yup.string()
    .required("Address Line 1 is required")
    .max(500, "Address Line 1 cannot exceed 500 characters"),

  address2: Yup.string()
    .max(500, "Address Line 2 cannot exceed 500 characters")
    .nullable(),

  city: Yup.string()
    .required("City is required")
    .max(100, "City cannot exceed 100 characters"),

  email: Yup.string()
    .required("Email is required")
    .email("Please enter a valid email address")
    .max(255, "Email cannot exceed 255 characters"),

  state: Yup.string()
    .required("State is required")
    .max(30, "State cannot exceed 30 characters"),

  country: Yup.string()
    .nullable()
    .transform((value) => (value && String(value).trim() ? String(value).trim() : ""))
    .test(
      "iso2-or-empty",
      "Please select a valid country",
      (value) => !value || /^[A-Z]{2}$/.test(value),
    ),

  postal_code: Yup.string()
    .required("Postal code is required")
    .max(20, "Postal code cannot exceed 20 characters"),

  phone: Yup.string().max(50, "Phone cannot exceed 50 characters").nullable(),
});

export const setBillingInfoValues = ({ billingInfoData, setFieldValue }) => {
  setFieldValue("company_name", billingInfoData.company_name || "", true);
  setFieldValue(
    "internal_company_number",
    billingInfoData.internal_company_number
      || billingInfoData.internalCompanyNumber
      || "",
    true,
  );
  setFieldValue("first_name", billingInfoData.first_name || "", true);
  setFieldValue("last_name", billingInfoData.last_name || "", true);
  setFieldValue("address1", billingInfoData.address1 || "", true);
  setFieldValue("address2", billingInfoData.address2 || "", true);
  setFieldValue("city", billingInfoData.city || "", true);
  setFieldValue("email", billingInfoData.email || "", true);
  setFieldValue("phone", billingInfoData.phone || "", true);
  setFieldValue("state", billingInfoData.state || "", true);
  setFieldValue(
    "country",
    normalizeKycCountryValue(billingInfoData.country || ""),
    true,
  );
  setFieldValue("postal_code", billingInfoData.postal_code || "", true);
};
